/* eslint-disable */
import rootApi from '@utils/baseAPI/WrapperApi';

// Role APIs
export const apiGetRoles = (data) => {
  return rootApi.get('api/roles', { params: data });
};

export const apiGetAllRoles = (data) => {
  return rootApi.get('api/roles/all', { params: data });
};

export const apiCreateRole = (data) => {
  return rootApi.post('api/role', data);
};

export const apiUpdateRole = (data, id) => {
  return rootApi.put(`api/role/${id}`, data);
};

export const apiDeleteRole = (id) => {
  return rootApi.delete(`api/role/${id}`);
};

// Permission APIs
export const apiGetPermissions = (data) => {
  return rootApi.get('api/permissions', { params: data });
};

export const apiGetAllPermissions = (data) => {
  return rootApi.get('api/permissions/all', { params: data });
};

export const apiCreatePermission = (data) => {
  return rootApi.post('api/permission', data);
};

export const apiUpdatePermission = (data, id) => {
  return rootApi.put(`api/permission/${id}`, data);
};

export const apiDeletePermission = (id) => {
  return rootApi.delete(`api/permission/${id}`);
};

// Role-Permission Assignment APIs
export const apiAssignPermissionsToRole = (data) => {
  return rootApi.post('api/role/assign-permissions', data);
};

export const apiGetRolePermissions = (roleId) => {
  return rootApi.get(`api/role/${roleId}/permissions`);
};

// User-Role Assignment APIs
export const apiAssignRolesToUser = (data) => {
  return rootApi.post('api/user/assign-roles', data);
};

export const apiGetUserRoles = (userId) => {
  return rootApi.get(`api/user/${userId}/roles`);
};

export const apiRemoveRoleFromUser = (data) => {
  return rootApi.delete('api/user/remove-role', { data });
};
